<template>
  <div class="time">{{time}}</div>
</template>

<script>
  export default {
    name: 'Time',
    props: ['time']
  }
</script>



// WEBPACK FOOTER //
// src/components/Time.vue